import React from "react"
import styled from "styled-components"
import { Link } from "./"
import Logo from "./Logo"

const Container = styled(Link)`
  display: block;
  position: absolute;
  right: 0;
  top: 0;
  width: 9.8em;
  @media (max-width: 500px) {
    width: 98px;
  }
`

export default ({ style, mt }) => (
  <Container to={"/"} mt={mt || 4} pr={[3, 3, 4]} style={style}>
    <Logo width="100%" />
  </Container>
)
